// 渠道管理相关接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 母渠道管理 - 母渠道code选项
export function getChannelCodeOptions(params){
  return get(baseApi + '/landingPageChannelConfig/channelList', params);
}
// 母渠道管理 - 子渠道code选项
export function getSubChannelCodeOptions(params){
  return get(baseApi + '/landingPageSubChannelConfig/subChannelList', params);
}


// 赠转短链路数据 - 列表
export function getZzdStatsList(params){
  return get(baseApi + '/landingPageSubChannelConfig/sub/export', params);
}
// 赠转短链路数据 - 子渠道code选项
export function getZzdSubChannelCodeOptions(params){
  return post(baseApi + '/landingPageSubChannelConfig/list', params);
}
// 赠转短链路数据 - 失效
export function unValidZzdStats(params){
  return get(baseApi + '/landingPageSubChannelConfig/channelExport', params);
}

// 获取黑牛客服电话
export function getHnServiceTel(params){
  return get(apiPrefix.hnBase + '/ua/api/userAccount/customer/service/tel', params);
}
